import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-five-lesson-six-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitFiveLessonSixGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 5, Lesson 6 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 6: Final Reflection";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
